import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export const getRouter = () => {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    scrollRestoration: true,
    notFoundMode: 'root',
  })
}
